/**
 * Sculpt-input helpers shared by the viewport interaction layer and tests.
 *
 * Pen input keeps its live pressure curve. Mouse and touch have no useful
 * analog range for sculpting here, so they run at a fixed full-pressure
 * baseline to avoid feeling artificially weak.
 */

export const NON_PEN_SCULPT_PRESSURE = 1;

export function resolveSculptPointerPressure(
  pointerType: string,
  pressure: number,
): number {
  return pointerType === "pen" ? pressure : NON_PEN_SCULPT_PRESSURE;
}
